import { useRevalidator, useRouteError } from 'react-router'

import {
  FeedbackNetworkError,
  FeedbackUnknownError,
} from '@/components/feedbacks'
import { getSentryEventId } from '@/queries/utils/sentry-events-id'
import { NetworkError } from '@/services/fintalk/api/types/errors/NetworkError'

export function SessionLoaderErrorElement() {
  const error = useRouteError()
  const revalidator = useRevalidator()

  const Feedback =
    error instanceof NetworkError ? FeedbackNetworkError : FeedbackUnknownError

  return (
    <div className="flex min-h-screen w-full items-center justify-center">
      <Feedback
        eventId={getSentryEventId(error)}
        onRetry={() => revalidator.revalidate()}
        isRetrying={revalidator.state === 'loading'}
      />
    </div>
  )
}
